import { render, staticRenderFns } from "./headers.vue?vue&type=template&id=6788567b&scoped=true&"
import script from "./headers.vue?vue&type=script&lang=js&"
export * from "./headers.vue?vue&type=script&lang=js&"
import style0 from "./headers.vue?vue&type=style&index=0&id=6788567b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6788567b",
  null
  
)

export default component.exports